import React from 'react';
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import { parseHTMLEvent, showModal, remoteURL, goTo, pageGoTo } from "../common";

const options = {
    decodeEntities: true,
    transform
}

function transform (node, index) {
    if (node.type === 'tag' && node.name === 'div' ) {
        if (node.attribs && node.attribs.href) {
            node.name = 'a';
        }
    }
    else if (node.type === 'tag' && node.name === 'p' ) {
        if (node.children.length > 0) {

        }
    }

    else if (node.type === 'tag' && node.name === 'table' ) {
        // console.log('edit table info here.');
    }

    return convertNodeToElement(node, index, transform);
}

function editRef (obj, internal) {
    if ( typeof internal === 'undefined' ) { internal = false; } 

    let _r = obj;
    const uri = obj.props.href;
    if (typeof uri !== 'undefined' && uri.startsWith('#')) { internal = true; }

    _r.props.onClick = (event) => {
        if (typeof uri !== 'undefined') { 
            let _uri;
            if (uri.includes('#')) {
                if (internal) {
                    _uri = uri.replace('#','')
                    return pageGoTo(_uri, 56);
                } else {
                    _uri = uri;
                    if (_uri.startsWith("'")) {
                        _uri.replace(/'/g, "");
                    }
                    if (_uri.endsWith("'")) {
                        _uri.replace(/'/g, "");
                    }
                    return remoteURL(_uri);
                }
            } else {
                _uri = uri;
                if (_uri.startsWith("'")) {
                    _uri.replace(/'/g, "");
                }
                if (_uri.endsWith("'")) {
                    _uri.replace(/'/g, "");
                }
                return remoteURL(_uri);
            }   
        } else {
            // console.log('no uri value...');
            return false;
        }
    }

    if (internal && typeof _r.props['href'] !== 'undefined') {
        delete _r.props['href'];
    }

    if (internal && typeof _r.props['target'] !== 'undefined') {
        delete _r.props['target'];
    }

    return _r;
}

function editRefLink (obj) {
    let _r = obj;

    for (const i of _r) {
        if (i.type === 'p') {
            if (i.props.children) {
                let children = i.props.children;

                for (const child of children) {
                    if (child === null || child.type === 'string') {
                        // console.log('child: ', child)
                    } else if (typeof child !== 'string' && typeof child === 'object') {
                        if (typeof child.type !== 'undefined' && child.type === 'sup') {
                            for (const sup of child.props.children) {
                                if (typeof sup.type !== 'undefined' && sup.type === 'a') {
                                    sup = editRef(sup, true);
                                    // console.log('sup tag', sup);
                                }
                            }
                        } else if (typeof child !== 'string' && child.type === 'div') {

                        } else if (typeof child !== 'string' && child.type === 'a') {
                            // console.log('a tag: ', child);
                            child = editRef(child, true);
                        }
                    } else if (Array.isArray(child)) {
                        for (const a of child) {
                            if (typeof a.type !== 'undefined' && a.type === 'a') {
                                a = editRef(a, true);
                                // console.log('a tag', a);
                            }
                        }
                    } 
                }
            } 
            /*else if (typeof i.type !== 'undefined' && i.type === 'a') {
                i = editRef(i);
            }*/
        } 
        /*else if (typeof i.type !== 'undefined' && i.type === 'a') {
            i = editRef(i);
        }*/
    }

    // console.log(_r);

    return _r;
}

function fixHTML (str) {
    let _html = str;
    _html = _html.replace(/<\/sup><sup/gi, ',</sup><sup');
    _html = _html.replace(/<\/p><table/gi, '</p><div class="table-responsive"><table');
    _html = _html.replace(/<\/div><table/gi, '</div><div class="table-responsive"><table');
    _html = _html.replace(/<\/table>/gi, '</table></div>');
    _html = _html.replace(/<\/table><\/div><\/div>/gi, '</table></div>');
    _html = _html.replace(/,,/gi, ',')

    return _html;
} 

export class HtmlComponent extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        let _html = fixHTML(this.props.html);
        let _comp = editRefLink( ReactHtmlParser(_html, options) );

        // console.log('HTMLComponent: ', _html);

        return (
            <div>{ _comp }</div>
        );
    }
        
}